import httpClient from "@/services/HttpService";

export default {

    availableUsers: async () => {
        return ( await httpClient.get('/chat/users/available')).data;
    },

}